<template>
  <div class="overflow-hide">
    <div class="flex justify-center items-center p-8">
      <div :class="`grid grid-cols-${columns} gap-8 w-full max-w-full`">
      <!--<transition-group 
       v-if="showProducts"
        :name="transitionName" 
        tag="div" 
        :class="`grid grid-cols-${columns} gap-8 w-full max-w-full`"  
      >-->
        <FoodCard 
          v-for="product in paginatedProducts" 
          :key="product.id" 
          :product="product" 
          :baseurl="baseurl" 
          :currency="currency"
        />
      <!--</transition-group>-->
       </div>
    </div>
  </div>
</template>



<script>
import { getDigitalMenu } from "@/API/API"; // فرض کنیم این متد API را فراخوانی می‌کند
import FoodCard from '@/components/VerticalFoodCard';

export default {
  name: 'DigitalMenu',
  components: { FoodCard },
  props: {
    currency: String,
    shop: String,
    menuId: Number,
    lanid: Number,
  },
  data() {
    return {
      products: [], // در ابتدا خالی است
      currentPage: 0,
      rows: 2, // مقدار پیش‌فرض برای سطر
      columns: 3, // مقدار پیش‌فرض برای ستون
      timerDuration: 7000, // مقدار پیش‌فرض تایمر
      //transitionName: "rotate-zoom",
      baseurl : process.env.VUE_APP_APIDOMAIN,
      showProducts: true,
    };
  },
  computed: {
    itemsPerPage() {
      return this.rows * this.columns; // تعداد آیتم‌ها بر اساس سطر و ستون
    },
    paginatedProducts() {
      const start = this.currentPage * this.itemsPerPage;
      return this.products.slice(start, start + this.itemsPerPage);
    }
  },
  async mounted() {
    this.rows = this.$route.query.rows || this.rows;
    this.columns = this.$route.query.columns || this.columns;
    //this.transitionName = this.$route.query.transitionName || this.transitionName;
    this.timerDuration = this.$route.query.timerDuration || this.timerDuration;

    await this.fetchProducts(); // وقتی کامپوننت بارگذاری شد، محصولات را بگیر
    this.startPageTimer();  // تایمر تغییر صفحه شروع شود
  },
  methods: {
    async fetchProducts() {
        try {
          const response = await getDigitalMenu(this.$route.params.slug, this.$route.params.id, this.$route.params.lanid); // کال API
          this.products = response.data; // داده‌های محصولات را در products قرار می‌دهیم
        } catch (error) {
          console.error('Error fetching products:', error);
        }
      },
      startPageTimer() {
        setInterval(() => {
          this.nextPage();
        }, this.timerDuration);  // تغییر صفحه بر اساس تایمر
      },
      nextPage() {
  // ابتدا محصولات را مخفی کنید
  this.showProducts = false;

  this.$nextTick(() => {
    setTimeout(() => {
      // تغییر صفحه
      if ((this.currentPage + 1) * this.itemsPerPage >= this.products.length) {
        this.currentPage = 0;
      } else {
        this.currentPage++;
      }

      // بعد از یک تأخیر کوتاه، محصولات را دوباره نشان دهید
      this.$nextTick(() => {
        this.showProducts = true;
      });
    }, 300);  // تأخیر 300 میلی‌ثانیه (می‌توانید تنظیم کنید)
  });
}

}

};
</script>

<style scoped>
.rotate-zoom-enter-active, .rotate-zoom-leave-active {
  transition: transform 0.5s ease;
}
.rotate-zoom-enter {
  transform: rotate(45deg) scale(0.5);
}
.rotate-zoom-leave-to {
  transform: rotate(-45deg) scale(0.5);
}
.bounce-enter-active, .bounce-leave-active {
  transition: transform 0.5s ease;
}
.bounce-enter {
  transform: translateY(-50px);
}
.bounce-leave-to {
  transform: translateY(50px);
}
.flip-enter-active, .flip-leave-active {
  transition: transform 0.5s ease;
}
.flip-enter {
  transform: rotateY(180deg);
}
.flip-leave-to {
  transform: rotateY(180deg);
}
.rotate-enter-active, .rotate-leave-active {
  transition: transform 0.5s ease;
}
.rotate-enter {
  transform: rotate(90deg);
}
.rotate-leave-to {
  transform: rotate(-90deg);
}
.zoom-enter-active, .zoom-leave-active {
  transition: transform 0.5s ease;
}
.zoom-enter {
  transform: scale(0.8);
}
.zoom-leave-to {
  transform: scale(0.8);
}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease; /* زمان انیمیشن را به 1 ثانیه افزایش دادیم */
}
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

</style>
